module.exports = __webpack_public_path__ + "static/coinmetrics-9ca3cb6d557412253cf76ff5b9d1d773.svg";